<template>
    <v-container fluid :style="{padding: $vuetify.breakpoint.smAndDown ? '0px' : null}">
        <v-layout row>
            <v-flex
                xs10
                offset-xs1
            >
            <div id="video-container">
                <v-playback auto-play="play" :url="data"/>
            </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    props: ['content'],
    computed: {
        data() {
            if(this.content.includes('http')) {
                return this.content
            }
            else return videoUrl + this.content
        }
    },
    mounted() {
    }
}
</script>

<style>
.video-js.vjs-16-9 {
    padding-top: 75%;
    cursor: pointer;
}
</style>

